import * as React from "react";
import { default as ItemData, IPricelist } from "../data/item";
import { default as PricelistView } from "./pricelist";

interface ItemProps {
    data: ItemData,
    handleError: (e: any) => void
}

interface IState {
    lists: IPricelist[]
}

export default class Items extends React.Component<ItemProps, IState> {
    public state: IState = { lists: [] };

    private isActive = true;
    private file5001: HTMLInputElement | null = null;
    private fileBdv: HTMLInputElement | null = null;

    constructor(props: ItemProps) {
        super(props);
        this.props.data.getLists()
            .then(d => d && this.isActive && this.setState({ lists: d }))
            .catch(this.props.handleError);
    }

    public componentWillUnmount() {
        this.isActive = false;
    }

    public render() {
        return <div className="content">
            <h1>Prislister</h1>
            <div className="commands">
                <a className="button" href="#"
                    onClick={this.handleImport5001Clicked}>
                    <i className="fa fa-upload" /> Importer 5001-fil
                </a>
                <a className="button" href="#"
                    onClick={this.handleImportBdvClicked}>
                    <i className="fa fa-upload" /> Importer BDV-fil
                </a>
            </div>
            <div className="list">
                {
                    this.state.lists.map(l => <PricelistView key={l.id} data={this.props.data} list={l} />)
                }
            </div>
            <div className="hidden">
                <form>
                    <input type="file" ref={r => this.file5001 = r} onChange={this.convert5001} />
                    <input type="file" ref={r => this.fileBdv = r} onChange={this.convertBdv} />
                </form>
            </div>
        </div>;
    }

    private handleImport5001Clicked = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        if (this.file5001) {
            this.file5001.click();
        }
    }

    private handleImportBdvClicked = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        if (this.fileBdv) {
            this.fileBdv.click();
        }
    }

    private convert5001 = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (this.file5001 && this.file5001.files
            && this.file5001.files.length === 1) {
            const file = this.file5001.files[0];
            this.import5001(file);
        }
    }

    private convertBdv = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (this.fileBdv && this.fileBdv.files
            && this.fileBdv.files.length === 1) {
            const file = this.fileBdv.files[0];
            this.importBdv(file)
        }
    }

    private import5001(file: File) {
        this.props.data.import5001(file);
    }

    private importBdv(file: File) {
        this.props.data.importBdv(file);
    }
}


// WEBPACK FOOTER //
// ./src/items/items.tsx